import sanitizeHtml, { replaceCidLinks } from '../lib/htmlSanitizer';
import { API_ROUTES } from '../constants';

export function waiverWorkItemImageReplacer(
  workItemId: number,
  link: string,
): string {
  return replaceCidLinks(link, (imageName: string) => API_ROUTES.waiverWorkItemImage(workItemId, imageName));
}

export default function sanitizeWorkItemHtml(
  emailBodyHtml: string,
  workItemId: number,
): { __html: string } {
  return sanitizeHtml((link: string) => waiverWorkItemImageReplacer(workItemId, link), emailBodyHtml || '');
}
